import React, {useEffect, useState} from 'react';
import {useWebSocket} from '../../../context/websocket';
import {useSelector} from 'react-redux';
import './PricingSheetPage.scss';
import * as sheetActions from './PricingSheetApi';
import moment from 'moment';
import PricingSheetTableGrid from './PricingSheetTableGrid';

const PricingSheetPage = () => {
    const [pricingSheets, setPricingSheets] = useState([]);
    const [ready, setReady] = useState(false);
    const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
    const webSocketContext = useWebSocket();
    const profile = useSelector(state => state.appState.profile);
    const isPricingSheetEnabled = profile.feature_flags && profile.feature_flags.find(ff => ff.name === 'Pricing Sheets');

    useEffect(() => {
        if (profile.client_id) {
            const pricingSheetChannel = webSocketContext.consumer.subscriptions.create(
                {
                    channel: 'PricingSheetChannel',
                    client_id: profile.client_id,
                },
                {
                    received: (data) => setPricingSheets(data),
                },
            );

            return () => pricingSheetChannel.unsubscribe();
        }
    }, [profile.client_id]);

    useEffect(() => {
        sheetActions.getPricingSheets({}, (res) => {
            setPricingSheets(res.data);
            setLastUpdatedAt(res.last_updated_at);
            setReady(true);
        });
    }, []);

    if (!ready || !isPricingSheetEnabled) {
        return null;
    }

    return (
        <div className="pricing-sheet-page">
            <header>
                {profile.customer_logo_url && <img src={profile.customer_logo_url} className="logo" alt="Company logo" />}
                {pricingSheets.length > 0 ?
                    <b>Inventory - updated as of {moment(lastUpdatedAt).format('LL')}</b> :
                    <b>Unfortunately, it seems like our pricing sheet is as current as the finest lumber in the yard - there are no updates available at the moment.</b>
                }
            </header>
            <div className="tables">
                {pricingSheets.map(p => <PricingSheetTableGrid data={p} />)}
            </div>
            <span className="powered-by-label">
                Powered by Traece<span className="registered-trademark-sign">&#174;</span>
            </span>
        </div>
    );
};

export default PricingSheetPage;


// WEBPACK FOOTER //
// ./src/containers/embeddable/pricing_sheet/PricingSheetPage.js